import {HttpClient} from "../../service/httpClient/HttpClient";

export class UsersListService {

    constructor() {
        this.httpClient = new HttpClient()
    }

    getUserList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `users`,
                {
                    page, size,
                }
            ).then(resolve).catch(reject)
        })
    }

    getUserStatistical() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `users/statistical/summary`
            ).then(resolve).catch(reject)
        })
    }
}